import { render, staticRenderFns } from "./BadgeUrgent.vue?vue&type=template&id=45933a3d&scoped=true&"
var script = {}
import style0 from "./BadgeUrgent.vue?vue&type=style&index=0&id=45933a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45933a3d",
  null
  
)

export default component.exports